jQuery(document).ready(function ($) {
  $("#CartDrawerForm .js-drawer-close, .add-to-cart").each(function() {
    $(this).on('click', function() {
      $.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'json',
        success: function(data) {
          var $cartLink = $('.cart-link .cart-link__bubble');
          if (data.item_count) {
            $cartLink.addClass('cart-link__bubble--visible');
            $cartLink.html('<span class="icon__fallback-text">Cart - contains items</span>');
          } else {
            $cartLink.removeClass('cart-link__bubble--visible');
            $cartLink.html('');
          }
        }
      });
    });
  });

  $('.template-product .custom-content .custom__item-inner--image a[href*="5C-2j-48Ct4"]').attr({
    target:'_blank', 
    'aria-label':'Play youtube video, Cobian rise collection'
  });
  
  
  $('.site-header__search-input').on('keydown', function(e) {
    switch (e.which) {
      case 40:
        e.preventDefault();
        $('#PredictiveResults a:first').focus(); 
        break;
        
    }
    
    $(this).attr('aria-expanded', $('.predictive-results').hasClass('hide'));
  });

  $('#PredictiveResults').on('keydown', function(e) {
    var $activeElement = $(document.activeElement);

    switch (e.which) {
      case 27:
        $('.site-nav__link.site-nav__link--icon.js-search-header').focus();
        break;
        
      case 38:
        e.preventDefault();
        var prev = Array($activeElement.parent().prev().find('a'), $activeElement.closest('div').prev().find('a:last'), $('.site-header__search-input'));
        prev.every($e => {
          if ($e.length) {
            $e.focus();
            return false;
          }

          return true;
        });
        break;
        
      case 40:
        e.preventDefault();
        var next = Array($activeElement.parent().next().find('a'), $activeElement.closest('div').next().find('a:first'), $('.predictive-results__footer button'));
        next.every($e => {
          if ($e.length) {
            $e.focus();
            return false;
          }
          
          return true;
        });
        break;
    }
  });
  
  $(document).on('focus', '#PredictiveWrapper a', function() {
    $('.site-header__search-input').attr('aria-activedescendent', $(this).attr('id'));
  });

  //ADA DESKTOP NAV
  $('.site-nav--is-megamenu').on('mouseover', function() {
    var $menuItem = $(this).find('.site-nav__link--has-dropdown');
    $('.site-nav--is-megamenu').not(this).removeClass('is-focused-nav');
    $(this).addClass('is-focused-nav');
    $('.site-nav__link--has-dropdown').not($menuItem).attr('aria-expanded', false);
    $menuItem.attr('aria-expanded', true);
  });

  $('.site-nav--is-megamenu .site-nav__link--has-dropdown').on('click', function() {
    var $parent = $(this).parent();
    $('.site-nav--is-megamenu').not($parent).removeClass('is-focused-nav');
    $parent.toggleClass('is-focused-nav');
    $('.site-nav__link--has-dropdown').not(this).attr('aria-expanded', false);
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true';
    });
  });

  $('.site-nav--is-megamenu, .megamenu').on('mouseout', function() {
    if (!$('.site-nav--is-megamenu:hover, .megamenu:hover').length) {
      $('.site-nav--is-megamenu').removeClass('is-focused-nav');
      $('.site-nav__link--has-dropdown').attr('aria-expanded', false);
    }
  });
  
  //ADA CART DRAWER TRAP
    var cart_close = function () {
      $('.js-drawer-open-cart').attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });
      var focusable = $('a, area, audio controls, button, iframe, input, fieldset, [role="button"], [role="tab"], .hero.flickity-enabled, select, summary, textarea, video controls');
      var focusoc = $('#CartDrawer a, #CartDrawer button');

      $(focusable).not(focusoc).attr('aria-hidden', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });

      $(focusable).not(focusoc).attr('tabindex', function (i, attr) {
      return attr == '-1' ? '' : '-1' });

      $(focusoc).attr('tabindex', function (i, attr) {
      return attr == '0' ? '' : '0' });
    };

    $('.js-drawer-open-cart, #CartDrawer .js-drawer-close').on('click', function() {
      cart_close();
    });
      
    $('#CartDrawer').on('keydown', function(e) {
      switch (e.which) {
        // esc
        case 27:
          cart_close();
      }
    }); 

  $(document).on('modalOpen', function() {
    var $modal = $('.modal--is-active');
    var $focusableElements = $modal.find('button, a, input, select, textarea');
    
    $modal.find('.modal__close').on('click keydown', function(e) {

      if (e.type === 'keydown') {
        if (e.key === 'Tab' || e.keyCode === 9) {
          return;
        }
      }
      
      $(document).find('button, a, input, select, textarea').each(function() {
        $(this).attr('tabindex', '0');
      });

      $focusableElements.each(function() {
        $(this).attr('tabindex', '-1');
      });

      if (e.type === 'click') {
        var $quickShopBtn = $modal.parent().find('.quick-product__btn');

        if ($quickShopBtn.length) {
          $quickShopBtn.focus();
        }
      }
    });

    $(document).find('button, a, input, select, textarea').each(function() {
      $(this).attr('tabindex', '-1');
    });

    $focusableElements.each(function() {
      $(this).attr('tabindex', '0');
    });
  });

  //ADA HEADER SEARCH TRAP
    $('.site-nav__link.site-nav__link--icon.js-search-header').on('click', function () {
      $('.js-search-header').attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });
      var focusable = $('a, area, audio controls, button, iframe, input, fieldset, [role="button"], [role="tab"], .hero.flickity-enabled, select, summary, textarea, video controls');
      var focusoc = $('.site-header__search a, .site-header__search button, .site-header__search input');

      $(focusable).not(focusoc).attr('aria-hidden', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });

      $(focusable).not(focusoc).attr('tabindex', function (i, attr) {
      return attr == '-1' ? '' : '-1' });

      $(focusoc).attr('tabindex', function (i, attr) {
      return attr == '0' ? '' : '0' });
    });
  
 
    var search_close = function () {
     $('.js-search-header').attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });
      var focusable = $('a, area, audio controls, button, iframe, input, fieldset, [role="button"], [role="tab"], .hero.flickity-enabled, select, summary, textarea, video controls');
      var focusoc = $('.site-header__search a, .site-header__search button, .site-header__search input');

      $(focusable).not(focusoc).attr('aria-hidden', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });

      $(focusable).not(focusoc).attr('tabindex', function (i, attr) {
      return attr == '-1' ? '' : '-1' });

      $(focusoc).attr('tabindex', function (i, attr) {
      return attr == '0' ? '' : '0' });

      $('.site-nav__link.site-nav__link--icon.js-search-header').focus();
    }

    $('.site-header__search-input, .site-nav__link.site-nav__link--icon.js-search-header, .predictive-results, .text-link.site-header__search-btn').on('keydown', function(e) {
      switch (e.which) {
        // esc
        case 27:
          search_close();
      }
    });
  
    $('.site-header__search button#SearchClose').on('click', function () {
       search_close();
    });

  //ADA MOBILE NAV TRAP

    $('.js-drawer-open-nav, #NavDrawer .drawer__close-button').on('click', function () {
      $('.js-drawer-open-nav').attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });
      var focusable = $('a, area, audio controls, button, iframe, input, fieldset, [role="button"], [role="tab"], .hero.flickity-enabled, select, summary, textarea, video controls');
      var focusoc = $('#NavDrawer a, #NavDrawer button');

      $(focusable).not(focusoc).attr('aria-hidden', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });

      $(focusable).not(focusoc).attr('tabindex', function (i, attr) {
      return attr == '-1' ? '' : '-1' });

      $(focusoc).attr('tabindex', function (i, attr) {
      return attr == '0' ? '' : '0' });
    });

  //ADA PRODUCT FILTER TRAP
    
    var mobile_nav_close = function () {
      $('#FilterDrawerTrigger').attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });
      var focusable = $('a, area, audio controls, button, iframe, input, fieldset, [role="button"], [role="tab"], .hero.flickity-enabled, select, summary, textarea, video controls');
      var focusoc = $('#FilterDrawer a, #FilterDrawer button, #FilterDrawer input');

      $(focusable).not(focusoc).attr('aria-hidden', function (i, attr) {
      return attr == 'true' ? 'false' : 'true' });

      $(focusable).not(focusoc).attr('tabindex', function (i, attr) {
      return attr == '-1' ? '' : '-1' });

      $(focusoc).attr('tabindex', function (i, attr) {
      return attr == '0' ? '' : '0' });
    };

    $('#FilterDrawerTrigger, #FilterDrawer .drawer__close-button').on('click', function() {
      mobile_nav_close();
    });
  
    $('#NavDrawer').on('keydown', function(e) {
      switch (e.which) {
        // esc
        case 27:
          mobile_nav_close();
      }
    });

    //$('.grid-product__has-quick-shop .grid-product__link').on('focus', function() {
    $(document).on('focus', '.grid-product__has-quick-shop .grid-product__link', function() {
      $('.grid-product__content').removeClass('quick-shop-hover');
      $(this).closest('.grid-product__content').addClass('quick-shop-hover');
    });

    //$('.grid-product__content').on('mouseenter mouseleave', function() {
    $(document).on('mouseenter mouseleave', '.grid-product__content', function() {
      $('.grid-product__content').removeClass('quick-shop-hover');
    });

    $('.pause-hero').on('click', function() {
      $(this).closest('.video-parent-section').get(0).dispatchEvent(new Event('video-pause'));
    });

    $('.play-hero').on('click', function() {
      $(this).closest('.video-parent-section').get(0).dispatchEvent(new Event('video-play'));
    });

    $('.collection-sidebar__group .tag input').on('focus', function() {
         $('.collection-sidebar__group .tag input').not(this).next().removeClass('swatchFocus'); 
       $(this).next().addClass('swatchFocus'); 
    });

    $('.collection-sidebar__group .tag input').last().on('blur', function() {
       $(this).next().removeClass('swatchFocus'); 
    });  
  
  });  
